// extracted by mini-css-extract-plugin
export default {"numberInputCell":"number-input-cell_numberInputCell__izcXh","flashing":"number-input-cell_flashing__PatkJ","flash":"number-input-cell_flash__g-e44"};